import React, { useState, useEffect } from 'react';
import { getSentAppreciations, getReceivedAppreciations } from '../services/appreciationService';
import AppreciationCard from '../components/appreciation/AppreciationCard';
import { useAppContext } from '../context/AppContext';

const MyAppreciations = () => {
  const { currentUser } = useAppContext();
  const [activeTab, setActiveTab] = useState('received');
  const [appreciations, setAppreciations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAppreciations = async () => {
      if (!currentUser || !currentUser.username) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        let data;

        if (activeTab === 'received') {
          data = await getReceivedAppreciations(currentUser.username);
        } else {
          data = await getSentAppreciations(currentUser.username);
        }

        // Sort by most recent first
        const sortedData = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setAppreciations(sortedData);
      } catch (error) {
        console.error('Error fetching appreciations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppreciations();
  }, [activeTab, currentUser]);

  return (
    <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">My Appreciations</h1>
        <p className="mt-2 text-sm text-gray-600">View all appreciations you've sent and received.</p>
      </div>
      
      <div className="mb-6">
        <div className="sm:hidden">
          <select
            className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value)}
          >
            <option value="received">Received</option>
            <option value="sent">Sent</option>
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              <button
                className={`${
                  activeTab === 'received'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                onClick={() => setActiveTab('received')}
              >
                Received
              </button>
              <button
                className={`${
                  activeTab === 'sent'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                onClick={() => setActiveTab('sent')}
              >
                Sent
              </button>
            </nav>
          </div>
        </div>
      </div>
      
      {loading ? (
        <div className="text-center py-10">Loading appreciations...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {appreciations.length > 0 ? (
            appreciations.map(appreciation => (
              <AppreciationCard key={appreciation.id} appreciation={appreciation} />
            ))
          ) : (
            <div className="col-span-3 text-center py-10 text-gray-500">
              No appreciations found. {activeTab === 'sent' ? 'Send some appreciation!' : 'Keep up the good work!'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MyAppreciations;
